import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Services from '../components/Services';
import Features from '../components/Features';
import PricingSection from '../components/PricingSection';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>mwbTechs - Enterprise SaaS Platform | CMMS & AI Chatbot</title>
        <meta
          name="description"
          content="Transform your business with mwbTechs. Enterprise CMMS, AI-powered chatbots, digital transformation consulting, and custom development services."
        />
        <meta
          name="keywords"
          content="CMMS, maintenance management, AI chatbot, digital transformation, custom development, SaaS platform"
        />
      </Helmet>

      <Hero />
      <Products />
      <Services />
      <Features />
      <PricingSection />
      {/* <Testimonials /> */}
      <CTA />
    </>
  );
};

export default Home;
